import discount from '@library/assets/images/icons/discount.svg';
import leTaco from '@library/assets/images/icons/leTaco.png';

export interface PromoIndicatorProps {
  className?: string;
  optIn: boolean;
}

export const PromoIndicator = ({
  className = 'flex h-4 w-fit self-center',
  optIn
}: PromoIndicatorProps) => {
  const { alt, src } = optIn
    ? { alt: 'Discount icon', src: discount }
    : { alt: 'Le Taco Icon', src: leTaco };

  return (
    <div className={className}>
      <img src={src} alt={alt} />
    </div>
  );
};
